import { render, staticRenderFns } from "./CheckQuery.vue?vue&type=template&id=040e5d32&scoped=true"
import script from "./CheckQuery.vue?vue&type=script&lang=js"
export * from "./CheckQuery.vue?vue&type=script&lang=js"
import style0 from "./CheckQuery.vue?vue&type=style&index=0&id=040e5d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e5d32",
  null
  
)

export default component.exports